// 账户管理
import request from '@/utils/request'
// 充值管理  - getList
export function getFiAcInputs(query) {
    return request({
        url: 'account/getFiAcInputs',
        method: 'GET',
        params: query
    })
}
// 充值管理  - view
export function viewFiAcInput(query) {
    return request({
        url: 'account/viewFiAcInput',
        method: 'GET',
        params: query
    })
}
// 充值管理  - save
export function saveOrUpdateFiAcInput(data) {
    return request({
        url: 'account/saveOrUpdateFiAcInput',
        method: 'POST',
        data
    })
}
// 充值管理  - 上传充值单图片
export function accountChargeImgs(data) {
    return request({
        url: '/account/chargeImgs',
        method: 'POST',
        data
    })
}
// 提现管理  - getList
export function getFiAcAppls(query) {
    return request({
        url: 'account/getFiAcAppls',
        method: 'GET',
        params: query
    })
}
// 提现管理  - view
export function viewFiAcAppl(query) {
    return request({
        url: 'account/viewFiAcAppl',
        method: 'GET',
        params: query
    })
}
// 提现管理  - cancel
export function fiAcApplCancel(query) {
    return request({
        url: 'account/fiAcApplCancel',
        method: 'GET',
        params: query
    })
}
// 提现管理  - save
export function saveOrUpdateFiAcAppl(data) {
    return request({
        url: 'account/saveOrUpdateFiAcAppl',
        method: 'POST',
        data
    })
}
// 提现管理获取基本信息
export function loadFiAcAppl(query) {
    return request({
        url: 'account/loadFiAcAppl',
        method: 'GET',
        params: query
    })
}
// 转账管理  - getList
export function getFiAcTrans(query) {
    return request({
        url: 'account/getFiAcTrans',
        method: 'GET',
        params: query
    })
}
// 转账管理  - save
export function saveOrUpdateFiAcTrans(data) {
    return request({
        url: 'account/saveOrUpdateFiAcTrans',
        method: 'POST',
        data
    })
}
// 账户管理  - getList
export function balance(query) {
    return request({
        url: 'account/balance',
        method: 'GET',
        params: query
    })
}
// 账户管理  - view
export function balanceView(query) {
    return request({
        url: 'account/balanceView',
        method: 'GET',
        params: query
    })
}
// 查询用户余额  - view
export function getFiAcBalance(query) {
    return request({
        url: 'account/getFiAcBalance',
        method: 'GET',
        params: query
    })
}
